import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { fetch_one, fetch_all } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import {
  Box,
  Button as Btn,
  Chip,
  CircularProgress,
  DialogActions,
  Grid,
  MenuItem,
  Tooltip,
} from '@mui/material';

import {
  Button,
  DatePicker,
  Dt,
  Editor,
  FileDrop,
  Select,
  TextInput,
  Typography
} from '../../../../components/v2/styled';

import { Advice } from '../../../../models/Advice';

const { DateTime } = require("luxon");

type Props = {
  onClick: (b:boolean) => void;
  open: boolean;
  setOpen: (b:boolean) => void;
  advice: Advice;
  clonedAdvice: Advice;
  setAdvice: (d:Advice) => void;
  loading?: boolean;
  isCompare?: boolean;
  activeCompare?: Advice;
};

export const CoachEditAdviceTab1: FunctionComponent<Props> = ({activeCompare, isCompare, loading, open, setOpen, advice, clonedAdvice, setAdvice, onClick}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const {t, i18n} = useTranslation(['translations']);

  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);

  return (<>
    {!advice.id && !activeCompare && (advice?.idx || 0) > 1 && <Grid item xs={!!activeCompare ? 6 : 12}>
      <Typography sx={{
        padding: 1,
        border: '1px solid transparent',
        borderColor: theme.palette.warning.main,
        borderRadius: 1
      }}>{t(!advice.cloned ? "coach.submenu.advices.help_set_cloned" : "coach.submenu.advices.help_set_empty")} <Button
        sx={{fontSize: '0.7rem', marginLeft: 1, marginTop: 0}}
        id="switch"
        size="small"
        onClick={(e) => {
          e.preventDefault();
          setFlickerEditor(true);

          if (!!advice.cloned) {
            setAdvice({
              attachments: [],
              advice_date: DateTime.now().toFormat("dd/LL/y"),
              episode: advice.episode,
              idx: advice.idx,
              identification: advice.identification
            });
          } else {
            setAdvice({
              ...clonedAdvice,
              advice_date: DateTime.now().toFormat("dd/LL/y")
            });
          }

          setTimeout(() => {setFlickerEditor(false);}, 200);
        }}
        label={t(!advice.cloned ? "coach.submenu.advices.cta_set_cloned" : "coach.submenu.advices.cta_set_empty")}
      /></Typography>
    </Grid>}

    <Grid item xs={!!activeCompare ? 2 : 12} md={2}>
      <TextInput
        id="idx"
        caption={t("client.models.advices.idx", "Index")}
        disabled={!!isCompare}
        placeholder={t("client.models.advices.placeholders.idx", "1")}
        value={advice?.idx?.toString() || ""}
        onChange={(e) => {
          setAdvice({
            ...advice,
            idx: !!e ? parseInt(e, 10) : 1
          });
        }}
      />
    </Grid>
    <Grid item xs={!!activeCompare ? 4 : 12} md={4}>
      <Typography variant="caption">{t("coach.models.advices.advice_date", "Datum")}</Typography><br/>
      <DatePicker
        disableFuture={false}
        openTo="day"
        label=""
        format={"dd/LL/y"}
        views={["year", "month", "day"]}
        setValue={(e) => {
          setAdvice({
            ...advice,
            advice_date: e
          });
        }}
        value={advice.advice_date || DateTime.now()}
        id={`advice_date${!!isCompare ? '_cmp' : ''}`}
        sx={{
          box: {
            width: 'auto',
            display: 'inline-block'
          },
          field_box: {
            "svg": {
              display: 'none'
            }
          },
          field: {
            width: 'auto',
            marginTop: 0,
            "input": {
              textAlign: 'center'
            }
          }
        }}
      />
    </Grid>

    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_current")}: {advice.identification} (<Dt o={advice.advice_date} />)</Typography>
    </Grid>}
    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_comparison")}: {activeCompare.identification} (<Dt d={activeCompare.advice_date} />)</Typography>
    </Grid>}
    <Grid item xs={!!activeCompare ? 6 : 12}>
      {!flickerEditor && <Editor
        advanced
        label={t("coach.models.advices.comment", "Aantekeningen")}
        value={advice?.comment || ""}
        onChange={(e) => {
          setAdvice({
            ...advice,
            comment: e
          });
        }}
      />}
    </Grid>
    {!!activeCompare && <Grid item xs={6}>
      {!flickerEditor && <Editor
        advanced
        disabled
        label={t("coach.models.advices.comment", "Aantekeningen")}
        value={activeCompare?.comment || ""}
        onChange={(e) => {
          
        }}
      />}
    </Grid>}
    <Grid item xs={!!activeCompare ? 6 : 12}>
      {!flickerEditor && <Editor
        advanced
        label={t("coach.models.advices.next_time")}
        value={advice?.next_time || ""}
        onChange={(e) => {
          setAdvice({
            ...advice,
            next_time: e
          });
        }}
      />}
    </Grid>
    {!!activeCompare && <Grid item xs={6}>
      {!flickerEditor && <Editor
        advanced
        disabled
        label={t("coach.models.advices.next_time")}
        value={activeCompare?.next_time || ""}
        onChange={(e) => {
          
        }}
      />}
    </Grid>}
    <Grid item xs={!!activeCompare ? 6 : 12}>
      {!flickerEditor && <Editor
        advanced
        label={t("coach.models.advices.internal_comment")}
        value={advice?.internal_comment || ""}
        onChange={(e) => {
          setAdvice({
            ...advice,
            internal_comment: e
          });
        }}
      />}
    </Grid>
    {!!activeCompare && <Grid item xs={6}>
      {!flickerEditor && <Editor
        advanced
        disabled
        label={t("coach.models.advices.internal_comment")}
        value={activeCompare?.internal_comment || ""}
        onChange={(e) => {
          
        }}
      />}
    </Grid>}
    <Grid item xs={!!activeCompare ? 6 : 12}>
      {/* <Dropzone
        filesLimit={5}
        maxFileSize={26214400}
        showFileNamesInPreview={true}
        showFileNames={true}
        initialFiles={this.state.active_advice.attachments ? this.state.active_advice.attachments.map((f) => f.attributes.url) : []}
        onChange={(files) => {
          this.setState({
            files: files
          });
        }}
      /> */}
      <Typography sx={{fontSize: '0.7rem'}}>{t("coach.models.advices.attachments_private", "Bijlagen, niet zichtbaar voor de client")}</Typography>
      <FileDrop
        onDrop={acceptedFiles => {setAdvice({
          ...advice,
          items_private: acceptedFiles
        });}}
        multiple={true}
        maxSize={20 * 1000 * 1000}
        items={advice.items_private}
        dropText="Click/Drop"
        dropHint="All.: all files, < 10mb"
      />
    </Grid>

    {!!advice.id && <Grid item xs={!!activeCompare ? 6 : 12}>
      <Box sx={{
        border: '1px solid transparent',
        borderColor: theme.palette.primary.main,
        padding: 1,
        borderRadius: 1,
        marginTop: 1
      }}>
        {!!advice && <Typography>{t("coach.submenu.advices.time_created")}: <Dt d={advice.created_at} f="cccc DDD t" />{!!advice.creator_id && ` ${t("general.terms.by")} ${advice.creator_full_name}`}</Typography>}
        {!!advice && <Typography>{t("coach.submenu.advices.time_updated")}: <Dt d={advice.updated_at} f="cccc DDD t" />{!!advice.editor_id && ` ${t("general.terms.by")} ${advice.editor_full_name}`}</Typography>}
      </Box>
    </Grid>}
    {!!activeCompare && !!activeCompare.id && <Grid item xs={6}>
      <Box sx={{
        border: '1px solid transparent',
        borderColor: theme.palette.primary.main,
        padding: 1,
        borderRadius: 1,
        marginTop: 1
      }}>
        {!!advice && <Typography>{t("coach.submenu.advices.time_created")}: <Dt d={activeCompare.created_at} f="cccc DDD t" />{!!activeCompare.creator_id && ` ${t("general.terms.by")} ${activeCompare.creator_full_name}`}</Typography>}
        {!!advice && <Typography>{t("coach.submenu.advices.time_updated")}: <Dt d={activeCompare.updated_at} f="cccc DDD t" />{!!activeCompare.editor_id && ` ${t("general.terms.by")} ${activeCompare.editor_full_name}`}</Typography>}
      </Box>
    </Grid>}
  </>);
}
